import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../../../store";
import DispatchProps from "../../../../utils/DispatchProps";
import ApiService from "../../../ApiService";
import Table, {TableColumn} from "../../../Table";
import {CommandBarButton} from "office-ui-fabric-react";
import JsonViewerCard from "../../../JsonViewerCard";
import {DirectoryObject, Group} from "@microsoft/microsoft-graph-types";
import SchoolPageTitle from '../../../SchoolPageTitle';
import AdminSchoolMenu from '../../../AdminSchoolMenu';



export interface GroupExploreResult
{
    group: Group,
    owners: DirectoryObject[],
    members: DirectoryObject[]
}
interface ExploreGroupPageProps {
    tenantId: string;
    schoolCode: string;
    groupId: string;
    apiService: ApiService;
}

interface ExploreGroupPageState {
    groupExploreResult?: GroupExploreResult;
    showJson: boolean;
}

const GROUP_COLUMNS: TableColumn[] = [
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Display Name",propertyPath: "displayName",enableSort: true, flex: 1},
    {title: "Mail Nickname",propertyPath: "mailNickname",enableSort: true,flex: 1},
    {title: "Created at",propertyPath: "createdDateTime",enableSort: true,type: "date",flex: 1},
];

const USER_COLUMNS: TableColumn[] = [
    {title: "Type",propertyPath: "@odata.type",enableSort: false, flex: 1},
    {title: "Id",propertyPath: "id",enableSort: false, flex: 1},
    {title: "Display Name",propertyPath: "displayName",enableSort: false, flex: 1},
    {title: "User Principal Name",propertyPath: "userPrincipalName",enableSort: false, flex: 1},
];

class ExploreGroupPage extends Component<ExploreGroupPageProps & DispatchProps, ExploreGroupPageState> {
    static displayName = ExploreGroupPage.name;

    constructor(props: ExploreGroupPageProps & DispatchProps) {
        super(props);

        this.state = {
            groupExploreResult: undefined,
            showJson: false
        }
    }

    async componentDidMount() {
        const groupExploreResult = await this.props.apiService.exploreGroup(this.props.tenantId,this.props.schoolCode,this.props.groupId);
        
        this.setState({
            groupExploreResult
        });
    }

    async componentDidUpdate(prevProps: Readonly<ExploreGroupPageProps & DispatchProps>, prevState: any): Promise<void> {

    }

    render() {
        
        const jsonButton = (
            <CommandBarButton
                iconProps={{ iconName: "code" }}
                text={"Show all json"}
                onClick={() => {
                    this.setState({ showJson: true })
                }}
            />
        );
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Explore Group" /> 

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                {this.state.showJson ? 
                    <JsonViewerCard title={""} jsonObject={this.state.groupExploreResult!}>
                        <CommandBarButton
                            iconProps={{ iconName: "cancel" }}
                            text={"Close"}
                            onClick={() => {
                                this.setState({ showJson: false })
                            }}
                        />
                    </JsonViewerCard> : null}
                
                <Table
                    title={this.state.groupExploreResult?.group.displayName}
                    columns={GROUP_COLUMNS}
                    items={this.state.groupExploreResult?.group ? [this.state.groupExploreResult.group] : []}>
                    {this.state.showJson ? null : jsonButton}
                </Table>
                
                
                <Table 
                    title={"Owners"}
                    columns={USER_COLUMNS}
                    items={this.state.groupExploreResult?.owners || []}/>

                <Table
                    title={"Members"}
                    columns={USER_COLUMNS}
                    items={this.state.groupExploreResult?.members || []}/>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): ExploreGroupPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;
        const groupId = ownProps.match.params.groupId;
        
        return {
            tenantId: tenantId,
            schoolCode: schoolCode,
            groupId: groupId,
            apiService: state.auth.apiService
        };
    }
)(ExploreGroupPage)